module.exports = __webpack_public_path__ + "img/ep5-2.340b7643.png";